(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cista-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cista-campaign-film')) {
  customElements.define('cista-campaign-film', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const video = this.querySelector('[data-cista-campaign-video]');
      if (!video) return;
      const controller = new AbortController();
      const { signal } = controller;
      const mobile = matchMedia('(max-width: 749px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      let inView = !('IntersectionObserver' in window);
      let source = '';
      let resumeTime = 0;
      let generation = 0;
      let pendingPlay = false;
      let blocked = false;
      let failed = false;
      let disconnected = false;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.controls = false;
      const canPlay = () => !disconnected && inView && !document.hidden &&
        !reducedMotion.matches && !connection?.saveData && !blocked && !failed;
      const selectSource = () => {
        const next = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!next || next === source) return;
        resumeTime = video.currentTime || 0;
        generation += 1;
        pendingPlay = false;
        failed = false;
        video.pause();
        video.classList.remove('is-visible');
        source = next;
        video.src = next;
        video.load();
      };
      const updatePlayback = () => {
        if (!canPlay()) {
          video.pause();
          if (reducedMotion.matches || connection?.saveData) video.classList.remove('is-visible');
          return;
        }
        if (!source) selectSource();
        if (!source || !video.paused || pendingPlay) return;
        const playGeneration = generation;
        pendingPlay = true;
        video.play().then(() => {
          if (playGeneration !== generation) return;
          pendingPlay = false;
          if (!canPlay()) video.pause();
        }).catch(error => {
          if (playGeneration !== generation || disconnected) return;
          pendingPlay = false;
          if (error.name === 'NotAllowedError') blocked = true;
          if (error.name !== 'AbortError') video.classList.remove('is-visible');
          else if (canPlay()) queueMicrotask(updatePlayback);
        });
      };
      video.addEventListener('loadedmetadata', () => {
        if (resumeTime > 0 && Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = resumeTime % video.duration;
        }
      }, { signal });
      video.addEventListener('playing', () => {
        if (!canPlay()) video.pause();
        else video.classList.add('is-visible');
      }, { signal });
      video.addEventListener('error', () => {
        failed = true;
        video.pause();
        video.classList.remove('is-visible');
      }, { signal });
      const retryAutoplay = () => {
        if (!blocked || reducedMotion.matches || connection?.saveData) return;
        blocked = false;
        updatePlayback();
      };
      document.addEventListener('pointerdown', retryAutoplay, { signal, passive: true });
      document.addEventListener('keydown', retryAutoplay, { signal });
      mobile.addEventListener('change', () => {
        if (source) selectSource();
        updatePlayback();
      }, { signal });
      reducedMotion.addEventListener('change', updatePlayback, { signal });
      connection?.addEventListener('change', updatePlayback, { signal });
      document.addEventListener('visibilitychange', updatePlayback, { signal });
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          inView = entry.isIntersecting && entry.intersectionRatio >= .15;
          updatePlayback();
        }, { threshold: [0, .15] });
        observer.observe(this);
      }
      this.cleanup = () => {
        disconnected = true;
        controller.abort();
        observer?.disconnect();
        generation += 1;
        video.pause();
        video.removeAttribute('src');
        video.load();
      };
      updatePlayback();
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cista-note"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cista-note-film')) {
    customElements.define('cista-note-film', class extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.connected = true;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.loop = true;
        this.video.controls = false;
        this.resume = () => {
          if (this.isConnected && !document.hidden && this.video.paused) this.video.play().catch(() => {});
        };
        this.video.addEventListener('canplay', this.resume);
        this.video.addEventListener('pause', this.resume);
        document.addEventListener('visibilitychange', this.resume);
        document.addEventListener('pointerdown', this.resume, { passive: true });
        window.addEventListener('pageshow', this.resume);
        this.resume();
      }
      disconnectedCallback() {
        if (!this.connected) return;
        this.video.removeEventListener('canplay', this.resume);
        this.video.removeEventListener('pause', this.resume);
        document.removeEventListener('visibilitychange', this.resume);
        document.removeEventListener('pointerdown', this.resume);
        window.removeEventListener('pageshow', this.resume);
        this.connected = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cista-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cista-proof')) {
  customElements.define('cista-proof', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const radios = Array.from(this.querySelectorAll('.cista-proof__radio'));
      const chapters = radios.map(radio => {
        const scene = this.querySelector('.cista-proof__scene[data-proof-panel="' + radio.value + '"]');
        const copy = this.querySelector('.cista-proof__copy [data-proof-panel="' + radio.value + '"]');
        return { scene, copy, video: scene?.querySelector('[data-proof-video]') };
      });
      const videos = chapters.map(chapter => chapter.video).filter(Boolean);
      const toggle = this.querySelector('[data-proof-toggle]');
      const stage = this.querySelector('.cista-proof__stage');
      if (!radios.length || chapters.some(chapter => !chapter.scene) || !toggle || !stage) return;
      const controller = new AbortController();
      const { signal } = controller;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      const staticDwell = 6000;
      let active = Math.max(0, radios.findIndex(radio => radio.checked));
      let inView = !('IntersectionObserver' in window);
      let userPaused = false;
      let manuallyStarted = false;
      let blocked = false;
      let failed = false;
      let chapterEnded = false;
      let visibleElapsed = 0;
      let clockStarted = null;
      let advanceTimer = null;
      let generation = 0;
      let pendingPlay = null;
      let disconnected = false;
      let swipe = null;
      let suppressClickUntil = 0;
      const currentVideo = () => chapters[active].video;
      const canRun = () => !disconnected && inView && !document.hidden &&
        (!reducedMotion.matches || manuallyStarted) && (!connection?.saveData || manuallyStarted) &&
        !userPaused && !blocked && !failed;
      const clearAdvance = () => {
        if (advanceTimer !== null) clearTimeout(advanceTimer);
        advanceTimer = null;
      };
      const freezeClock = () => {
        if (clockStarted !== null) visibleElapsed += performance.now() - clockStarted;
        clockStarted = null;
        clearAdvance();
      };
      const startClock = () => {
        if (clockStarted === null) clockStarted = performance.now();
      };
      const elapsed = () => visibleElapsed +
        (clockStarted === null ? 0 : performance.now() - clockStarted);
      const syncToggle = () => {
        toggle.hidden = false;
        const playing = !userPaused && !blocked && !failed &&
          (!connection?.saveData || manuallyStarted) && (!reducedMotion.matches || manuallyStarted);
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      };
      const syncPanels = () => {
        chapters.forEach((chapter, index) => {
          const selected = index === active;
          radios[index].checked = selected;
          [chapter.scene, chapter.copy].filter(Boolean).forEach(panel => {
            panel.dataset.active = String(selected);
            panel.setAttribute('aria-hidden', String(!selected));
          });
        });
      };
      const showPoster = video => {
        const poster = video?.parentElement.querySelector('[data-proof-poster]');
        if (poster) poster.hidden = false;
      };
      const pauseAll = () => videos.forEach(video => video.pause());
      const loadVideo = video => {
        video.preload = 'auto';
        if (!video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.load();
        } else if (video.error) {
          video.load();
        }
      };
      const rewindVideo = video => {
        if (video.readyState > 0 && (video.currentTime > 0 || video.ended)) video.currentTime = 0;
      };
      const prepareNext = () => {
        if (!canRun() || connection?.saveData) return;
        for (let offset = 1; offset < chapters.length; offset += 1) {
          const video = chapters[(active + offset) % chapters.length].video;
          if (!video || video === currentVideo()) continue;
          video.pause();
          loadVideo(video);
          rewindVideo(video);
          break;
        }
      };
      const scheduleStaticAdvance = () => {
        clearAdvance();
        if (currentVideo() || !canRun()) return;
        const remaining = Math.max(0, staticDwell - elapsed());
        const advanceGeneration = generation;
        advanceTimer = setTimeout(() => {
          advanceTimer = null;
          if (advanceGeneration !== generation || currentVideo() || !canRun()) return;
          if (elapsed() < staticDwell) {
            scheduleStaticAdvance();
            return;
          }
          selectChapter((active + 1) % chapters.length, false);
        }, remaining);
      };
      const updatePlayback = () => {
        if (!canRun()) {
          freezeClock();
          if (pendingPlay) {
            generation += 1;
            pendingPlay = null;
          }
          pauseAll();
          syncToggle();
          return;
        }
        const video = currentVideo();
        videos.forEach(otherVideo => {
          if (otherVideo !== video) otherVideo.pause();
        });
        if (!video) {
          startClock();
          prepareNext();
          scheduleStaticAdvance();
          syncToggle();
          return;
        }
        if (chapterEnded) {
          selectChapter((active + 1) % chapters.length, false);
          return;
        }
        loadVideo(video);
        if (!video.paused || pendingPlay) {
          if (!video.paused) prepareNext();
          syncToggle();
          return;
        }
        const request = { generation, video };
        pendingPlay = request;
        video.play().then(() => {
          if (request.generation !== generation || pendingPlay !== request) {
            if (video !== currentVideo() || !canRun()) video.pause();
            return;
          }
          pendingPlay = null;
          if (!canRun()) video.pause();
          else prepareNext();
        }).catch(error => {
          if (request.generation !== generation || pendingPlay !== request || disconnected) return;
          pendingPlay = null;
          if (error.name === 'NotAllowedError') { blocked = true; showPoster(video); }
          else if (error.name !== 'AbortError') failed = true;
          freezeClock();
          syncToggle();
          if (error.name === 'AbortError' && canRun()) queueMicrotask(updatePlayback);
        });
        syncToggle();
      };
      const selectChapter = (index, manual) => {
        freezeClock();
        generation += 1;
        pendingPlay = null;
        pauseAll();
        active = index;
        chapterEnded = false;
        failed = false;
        blocked = false;
        visibleElapsed = 0;
        syncPanels();
        if (manual) {
          manuallyStarted = true;
          userPaused = false;
        }
        const video = currentVideo();
        if (video) rewindVideo(video);
        updatePlayback();
      };
      chapters.forEach((chapter, index) => {
        const video = chapter.video;
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        const fallback = video.parentElement.querySelector('[data-proof-fallback]');
        const poster = video.parentElement.querySelector('[data-proof-poster]');
        video.addEventListener('loadeddata', () => {
          video.hidden = false;
          if (fallback) fallback.hidden = true;
        }, { signal });
        video.addEventListener('playing', () => {
          if (index !== active || !canRun()) {
            video.pause();
            return;
          }
          if (poster) poster.hidden = true;
          prepareNext();
        }, { signal });
        video.addEventListener('ended', () => {
          if (index !== active) return;
          chapterEnded = true;
          pendingPlay = null;
          if (canRun()) selectChapter((active + 1) % chapters.length, false);
        }, { signal });
        video.addEventListener('error', () => {
          if (index !== active) return;
          failed = true;
          pendingPlay = null;
          showPoster(video);
          if (fallback) { video.hidden = true; fallback.hidden = false; }
          freezeClock();
          video.pause();
          syncToggle();
        }, { signal });
      });
      this.addEventListener('change', event => {
        const index = radios.indexOf(event.target);
        if (index !== -1) selectChapter(index, true);
      }, { signal });
      this.addEventListener('click', event => {
        const index = radios.indexOf(event.target);
        if (index === active) selectChapter(index, true);
      }, { signal });
      stage.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        if (!event.isPrimary) {
          swipe = null;
          suppressClickUntil = performance.now() + 700;
          return;
        }
        suppressClickUntil = 0;
        swipe = { id: event.pointerId, x: event.clientX, y: event.clientY, chapter: active, axis: null };
      }, { signal, passive: true });
      stage.addEventListener('pointermove', event => {
        if (!swipe || event.pointerId !== swipe.id) return;
        const dx = Math.abs(event.clientX - swipe.x);
        const dy = Math.abs(event.clientY - swipe.y);
        if (Math.max(dx, dy) < 12) return;
        suppressClickUntil = performance.now() + 700;
        if (!swipe.axis) swipe.axis = dx > dy * 1.25 ? 'horizontal' : 'vertical';
      }, { signal, passive: true });
      stage.addEventListener('pointerup', event => {
        if (!swipe || event.pointerId !== swipe.id) return;
        const gesture = swipe;
        swipe = null;
        const dx = event.clientX - gesture.x;
        const dy = Math.abs(event.clientY - gesture.y);
        if (Math.max(Math.abs(dx), dy) >= 12) suppressClickUntil = performance.now() + 700;
        if (gesture.axis === 'vertical' || Math.abs(dx) < 48 || Math.abs(dx) < dy * 1.25) return;
        const direction = dx < 0 ? 1 : -1;
        selectChapter((gesture.chapter + direction + chapters.length) % chapters.length, true);
      }, { signal, passive: true });
      stage.addEventListener('pointercancel', () => {
        swipe = null;
        suppressClickUntil = performance.now() + 700;
      }, { signal, passive: true });
      toggle.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < suppressClickUntil) {
          event.preventDefault();
          return;
        }
        if (!userPaused && !blocked && !failed && (!connection?.saveData || manuallyStarted) && (!reducedMotion.matches || manuallyStarted)) {
          userPaused = true;
        } else {
          userPaused = false;
          manuallyStarted = true;
          blocked = false;
          if (failed) {
            failed = false;
            generation += 1;
            pendingPlay = null;
            currentVideo()?.load();
          }
        }
        updatePlayback();
      }, { signal });
      document.addEventListener('visibilitychange', updatePlayback, { signal });
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) {
          manuallyStarted = false;
          pauseAll();
          videos.forEach(video => { rewindVideo(video); showPoster(video); });
        }
        updatePlayback();
      }, { signal });
      connection?.addEventListener('change', updatePlayback, { signal });
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          inView = entry.isIntersecting && entry.intersectionRatio >= .25;
          updatePlayback();
        }, { threshold: [0, .25] });
        observer.observe(this.querySelector('.cista-proof__stage'));
      }
      this.cleanup = () => {
        disconnected = true;
        generation += 1;
        pendingPlay = null;
        freezeClock();
        controller.abort();
        observer?.disconnect();
        pauseAll();
        videos.forEach(video => {
          video.removeAttribute('src');
          video.load();
        });
      };
      syncPanels();
      syncToggle();
      updatePlayback();
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
